(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         * webhooksData - array of current we
         * webhook
         */
        .controller("webhookModal", ["$uibModalInstance", "WizardHandler", "webhook", 'availableEvents', 'availableTemplates', 'useBatch', '$sanitize',
            function ($uibModalInstance, WizardHandler, webhook, availableEvents, availableTemplates, useBatch, $sanitize) {

                var vm = this;
                vm.wizardTitle = "Create or update a webhook";

                vm.updating = false;

                vm.cancel = function () {
                    WizardHandler.wizard("webhookWizard").cancel();
                    $uibModalInstance.dismiss();
                }

                vm.create = function () {
                    WizardHandler.wizard("webhookWizard").finish();
                    $uibModalInstance.close(vm.buildRequest());
                }

                vm.nameExitValidation = function () {
                    return vm.nameNameStepForm.$valid;
                }

                vm.canEnterStepOne = function () {
                    return true;
                }

                vm.detailsExitValidation = function () {
                    return Object.values(vm.events).includes(true);
                }

                vm.availableEvents = availableEvents;
                vm.availableTemplates = availableTemplates;
                vm.templateData = { pickedTemplates: {} };
                vm.events = {};
                vm.filters = {};
                vm.newWebhook = {
                    batch: false,
                    maxBatchSize: 10,
                    batchTimeout: 1
                };
                vm.useBatch = useBatch;

                vm.getUsableName = function (name) {
                    return name.split(' ').join('_');
                };

                vm.sanitizeUrl = function sanitizeUrl(url) {
                    vm.newWebhook.url = $sanitize(url) || "";
                }
                vm.updateEventsByTemplate = function updateEventsByTemplate(index) {
                    var pickedTemplate = vm.availableTemplates[index].events;

                    if (vm.templateData.pickedTemplates[index]) {
                        pickedTemplate.forEach(function (e) {
                            if (!vm.events[e]) {
                                vm.events[e] = true;
                            }
                        });
                    } else {
                        var otherTemplateContainIt = false;
                        pickedTemplate.forEach(function (e) {
                            var listOfChosen = [];
                            for (var key in vm.templateData.pickedTemplates) {
                                if (vm.templateData.pickedTemplates.key) {
                                    listOfChosen.push(key);
                                }
                            }
                            listOfChosen.forEach(function (chosenIndex) {
                                if (vm.availableTemplates[chosenIndex].events.includes(e)) {
                                    otherTemplateContainIt = true;
                                    return;
                                }
                            }
                            );

                            if (vm.events[e] && !otherTemplateContainIt) {
                                vm.events[e] = false;
                            }
                        });
                    }
                }

                vm.updateTemplates = function updateTemplates(eventType) {
                    if (!vm.events[eventType]) {
                        for (var key in vm.templateData.pickedTemplates) {
                            if (vm.templateData.pickedTemplates[key]) {
                                if (vm.availableTemplates[key].events.includes(eventType)) {
                                    vm.templateData.pickedTemplates[key] = false;
                                }
                            }
                        }
                    } else {
                        vm.availableTemplates.forEach(function (template, index) {
                            if (!vm.templateData.pickedTemplates[index]) {
                                var containAll = true;
                                template.events.forEach(function (e) {
                                    if (!vm.events[e]) {
                                        containAll = false;
                                        return;
                                    }
                                });
                                if (containAll) {
                                    vm.templateData.pickedTemplates[index] = true;
                                }
                            }
                        })
                    }

                }


                vm.initialise = function () {
                    if (webhook) {

                        vm.updating = true;
                        vm.wizardTitle = "Update webhook";

                        vm.newWebhook.name = webhook.name;
                        vm.newWebhook.url = webhook.url;
                        vm.newWebhook.secret = webhook.secret;

                        vm.newWebhook.batch = webhook.batch;
                        vm.newWebhook.maxBatchSize = webhook.maxBatchSize;
                        vm.newWebhook.batchTimeout = webhook.batchTimeout;

                        var subs = webhook.subscriptions;
                        for (var sub in subs) {
                            var singleSub = subs[sub];
                            var singleSubType = singleSub.type;
                            vm.events[singleSubType] = true;
                            var filters = singleSub.filters;
                            var pushFilters = {};
                            for (var filter in filters) {
                                var singleFilter = filters[filter];
                                var singleFilterName = singleFilter.name;
                                pushFilters[singleFilterName] = singleFilter.value;
                            }
                            vm.filters[singleSubType] = pushFilters;
                        }

                    } else {
                        vm.wizardTitle = "Create webhook";
                    }
                }

                vm.buildRequest = function () {
                    var data = {
                        name: vm.newWebhook.name,
                        url: $sanitize(vm.newWebhook.url),
                        secret: vm.newWebhook.secret,
                        id: webhook ? webhook.id : undefined,
                    };
                    if (useBatch) {
                        data.batch = vm.newWebhook.batch;
                        data.maxBatchSize = vm.newWebhook.maxBatchSize;
                        data.batchTimeout = vm.newWebhook.batchTimeout;
                    }
                    if (vm.events && Object.keys(vm.events).length > 0) {
                        data.subscriptions = [];
                        for (var eventType in vm.events) {
                            var newSubscription = {
                                type: eventType
                            };
                            if (vm.events[eventType]) {
                                var filters = vm.filters[eventType];
                                var newFilters = [];
                                if (filters && Object.keys(filters).length > 0) {
                                    for (var filter in filters) {
                                        if (filters[filter]) {
                                            newFilters.push({
                                                name: filter,
                                                value: filters[filter]
                                            });
                                        }
                                    }
                                }
                                if (newFilters) {
                                    newSubscription.filters = newFilters;
                                }
                                data.subscriptions.push(newSubscription);
                            }
                        }
                    }

                    return data;

                }

                vm.initialise();

            }]);

})(window.angular);
